import { ColumnProps } from 'antd/lib/table';
import { getValueFromPath } from './data';

export enum ColumnTypes {
  String,
  Numeric,
  Date,
  Boolean,
  CustomComponent
}

export interface ExtendedColumnProps<T> extends ColumnProps<T> {
  dataType:ColumnTypes;
  isActionsColumn?: boolean;
  isDefaultColumn?: boolean;
  mapper?:(value: unknown, record?: unknown) => string|number|Date|null;
  filterType?: 'Search' | 'Dropdown';
  sorterKey?: string;
  showDataWithAction?: boolean;
  autoWidth?: boolean;
  isClickableColumn?: boolean;
  isHighLightedColumnClickable?: boolean;
}

export function getColumnValue<T>(record: T, column: ExtendedColumnProps<T>):string|number|Date|null {
  switch(column.dataType) {
  case ColumnTypes.Numeric:
    return getValueFromPath<T, number>(record, column.dataIndex as string, 0);
  case ColumnTypes.Date:
    return getValueFromPath<T, number>(record, column.dataIndex as string);
  case ColumnTypes.String:
  case ColumnTypes.CustomComponent:
    return getValueFromPath<T, string>(record, column.dataIndex as string, '');
  case ColumnTypes.Boolean:
    return getValueFromPath<T, string>(record, column.dataIndex as string, '');
  }
  return null;
}
